module.exports = __webpack_public_path__ + "img/gnubash-svgrepo-com.23949fd4.svg";